document.addEventListener("DOMContentLoaded", function () {
  const modalTriggers = document.querySelectorAll(".js-modal-open");
  const modalCloses = document.querySelectorAll(".js-modal-close");

  modalTriggers.forEach(trigger => {
    trigger.addEventListener("click", function () {
      const modalId = this.getAttribute("data-modal");

      // すべてのモーダルを非表示にする
      document.querySelectorAll(".js-modal-content").forEach(modal => {
        modal.classList.remove("is-active");
      });

      // クリックされた要素に対応するモーダルを表示
      const targetModal = document.querySelector(`.js-modal-content[data-modal-content="${modalId}"]`);
      if (targetModal) {
        targetModal.classList.add("is-active");
        document.querySelector("body").classList.add("no-scroll");
      }
    });
  });

  // モーダルを閉じる処理
  modalCloses.forEach(closeBtn => {
    closeBtn.addEventListener("click", function () {
      const modal = this.closest(".js-modal-content");
      modal.classList.remove("is-active");
      document.querySelector("body").classList.remove("no-scroll");

      // YouTube埋め込み動画の一時停止
      const iframe = modal.querySelector("iframe");
      if (iframe) {
        const src = iframe.src;
        iframe.src = ""; // 一旦srcを空にする
        iframe.src = src; // 再設定してリロード（再生が停止する）
      }

      // HTML5 video の一時停止
      const video = modal.querySelector("video");
      if (video) {
        video.pause(); // 一時停止
      }
    });
  });
});
